let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("28vxS")).then(() => parcelRequire('55Rtn'));